<template>
  <div style="width: 100%">
    <v-card>
      <v-card-title
        >Box Admin<v-icon right
          >mdi-phone-rotate-landscape</v-icon
        ></v-card-title
      >
      <div v-if="!loggedIn">
        <NeedLogin></NeedLogin>
      </div>
      <div v-else>
        <SelectBoxForAdmin
          @box_changed="boxSelected"
          v-if="showBoxList"
        ></SelectBoxForAdmin>

        <v-container fluid>
          <v-row>
            <v-col cols="2">
              <v-btn
                v-if="!showBoxList"
                @click="showBoxList = !showBoxList"
                small
                rounded
                color="primary"
                >Show Boxes</v-btn
              >
            </v-col>
            <v-col
              >SELECTED BOX:
              <v-chip color="primary">{{ this.boxname }} </v-chip></v-col
            >
          </v-row>
          <!-- <p>{{ radio || "null" }}</p> -->
          <v-row class="mb-8">
            <v-col cols="3">
              <v-radio-group
                v-model="radio"
                @change="radiochanged"
                dense
                v-if="boxIsSelected"
              >
                <v-radio
                  label="SMS"
                  value="Sms"
                  off-icon="mdi-cellphone-message"
                ></v-radio>
                <v-radio
                  label="Box Openers"
                  value="BoxOpeners"
                  off-icon="mdi-account-edit-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
                <v-radio
                  label="Edit"
                  value="Edit"
                  off-icon="mdi-square-edit-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
                <v-radio
                  label="Create"
                  value="Create"
                  off-icon="mdi-plus-circle-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
                <v-radio
                  label="Delete"
                  value="Delete"
                  off-icon="mdi-trash-can-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
                <v-radio
                  label="Edit templates"
                  value="Edit templates"
                  off-icon="mdi-square-edit-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
                <v-radio
                  label="Transfer pilots to new date"
                  value="Transfer"
                  off-icon="mdi-database-arrow-right-outline"
                  :disabled="!IsBoxAdmin"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col>
              <div v-if="radionumber == 1">
                <!-- {{ radio }} - Not implemented yet! -->
                <SendSmsMulti
                  :items="items"
                  :regId="regId"
                  :ac="ac"
                ></SendSmsMulti>
              </div>
              <div v-if="radionumber == 2">
                <BoxRoles v-bind="postbox"></BoxRoles>
              </div>
              <div v-if="radionumber == 3">
                <EditBox v-bind="postbox"></EditBox>
              </div>
              <div v-if="radionumber == 4">
                <CreateBox v-bind="postregidac"></CreateBox>
              </div>
              <div v-if="radionumber == 5">
                <DeleteBox v-bind="postbox"></DeleteBox>
              </div>
              <div v-if="radionumber == 6">
                <EditBoxTemplates v-bind="postbox"></EditBoxTemplates>
              </div>
              <div v-if="radionumber == 7">
                <TransferPilotsToNewDate
                  v-bind="postbox"
                ></TransferPilotsToNewDate>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- {{roles}} -->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import SelectBoxForAdmin from "@/components/airbox/SelectBoxForAdmin.vue";
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import BoxRoles from "@/components/Admin/BoxRoles.vue";
import CreateBox from "@/components/Admin/CreateBox.vue";
import DeleteBox from "@/components/Admin/DeleteBox.vue";
import EditBoxTemplates from "@/components/Admin/EditBoxTemplates.vue";
import TransferPilotsToNewDate from "@/components/Admin/TransferPilotsToNewDate.vue";
import SendSmsMulti from "@/components/Admin/SendSmsMulti.vue";
import axios from "axios";
import EditBox from "@/components/Admin/EditBox.vue";

export default {
  name: "Lsb",
  data() {
    return {
      startInput: 0,
      cookieToken: Number,
      cookieRegId: Number,
      regId: Number,
      ac: String,
      box: [],
      boxname: String,
      boxid: Number,
      boxIsSelected: false,
      showBoxList: true,
      items: [],
      // pilots: [],
      errors: [],
      radio: null,
      radionumber: Number,
      postbox: {
        box: [],
        regId: Number,
        ac: String,
      },
      postregidac: {
        regId: Number,
        ac: String,
      },
      roles: [],
      IsBoxAdmin: false,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";

    this.getCookies();
    this.box = null;
    this.boxname = "Box Not Selected";
    this.roles = null;
    this.IsBoxAdmin = false;
    this.getroles();
    // this.radionumber = 1;
  },
  methods: {
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regId = Number(this.cookieRegId);
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
    boxSelected(boxSelected) {
      this.box = boxSelected;
      this.boxname = boxSelected.Event;
      this.boxid = boxSelected.EventId;
      this.boxIsSelected = true;
      this.showBoxList = false;
      this.radionumber = null;
      this.radio = null;

      this.postbox.box = boxSelected;
      this.postbox.regId = this.regId;
      this.postbox.ac = this.ac;

      this.postregidac.regId = this.regId;
      this.postregidac.ac = this.ac;
    },
    radiochanged() {
      if (this.radio == "Sms") {
        this.radionumber = 1;
        this.getAirbox();
        // console.log("box", this.boxid);
        // console.log(this.pilots);
      }
      if (this.radio == "BoxOpeners") {
        this.radionumber = 2;
      }
      if (this.radio == "Edit") {
        this.radionumber = 3;
      }
      if (this.radio == "Create") {
        this.radionumber = 4;
      }
      if (this.radio == "Delete") {
        this.radionumber = 5;
      }
      if (this.radio == "Edit templates") {
        this.radionumber = 6;
      }
      if (this.radio == "Transfer") {
        this.radionumber = 7;
      }
    },
    getroles() {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      var uri = this.baseUrl + "getroles";
      var regId = this.regId;
      var roleId = 2;
      var toSubmit = JSON.stringify({ regId, roleId });
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.roles = response.data;
          if (this.roles[0].RoleId == 2) {
            this.IsBoxAdmin = true;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getAirbox() {
      var uri = this.baseUrl + "getlsbforadmin/" + this.boxid;
      var regId = this.regId;
      var ac = this.ac;
      var dato = "1900-01-01";
      //   var countrycode = this.valueInComponent
      var toSubmit = JSON.stringify({ regId, ac, dato });
      // console.log("toSubmit", toSubmit);
      // console.log("uri", uri);
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };

      axios

        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          console.log;
          this.items = response.data;
          this.loading = false;
          // console.log("pilots", this.items);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // findrole(arr,roleId){
    //   console.log(arr); console.log(roleId);
    //   this.roleAdminId = arr.find(roleId);
    // }
  },
  components: {
    SelectBoxForAdmin,
    NeedLogin,
    BoxRoles,
    CreateBox,
    DeleteBox,
    TransferPilotsToNewDate,
    EditBoxTemplates,
    SendSmsMulti,
    EditBox,
  },
};
</script>

          